import React, { Dispatch } from 'react';
import ApiClient from '../../../api/alms-api';
import Translator from '../../../core/i18n';
import { Log } from 'ng2-logger';
import { IActivityProgress } from '../../../models/components/lesson-activity-progress';
import { IAppState, IAction } from '../../../models/action/core';
import * as Actions from '../../../store/actions/coursePage';
import { connect } from 'react-redux';
import Loading from '../../loading/loading';
import ProgressCircleLarge from '../../progress-circle/progress-circle-large';
import ContentLoader from 'react-content-loader';

const T = Translator.create();
const _logger = Log.create('activity-progress.tsx');
const token: any = localStorage.getItem('access_token');
let _apiClient: ApiClient;

class ActivityProgress extends React.Component<IActivityProgress> {
    public courseNavigationn: HTMLDivElement | null = null;

    constructor(props: any) {
        super(props);
        _apiClient = new ApiClient();
    }

    public componentDidMount = () => {
        this.props.dispatch(Actions.getCourseClassActivityProgress(this.props.coursePageClassId!, 'getCourseClassActivityProgress', 'get'));
    };

    public componentWillReceiveProps = (nextProps: IActivityProgress) => {
        if (nextProps.coursePageClassId && this.props.coursePageClassId) {
            if (nextProps.coursePageClassId !== this.props.coursePageClassId) {
                nextProps.dispatch(
                    Actions.getCourseClassActivityProgress(nextProps.coursePageClassId, 'getCourseClassActivityProgress', 'get')
                );
            }
        }
    };

    public render() {
        const loadingSpaces = 96;
        return (
            <div className="white-box p-3">
                <Loading spinnerId={'getCourseClassActivityProgress'}>
                    <div style={{ backgroundColor: '#eeede9' }}>
                        <ContentLoader
                            speed={2}
                            backgroundColor="#f3f3f3"
                            foregroundColor="#ecebeb"
                            viewBox="0 0 350 125"
                            style={{ width: '100%' }}
                        >
                            <circle cx="35" cy="64" r="30" />
                            <circle cx="107" cy="64" r="30" />
                            <circle cx="180" cy="64" r="30" />
                            <circle cx="250" cy="64" r="30" />
                            <circle cx="320" cy="64" r="30" />

                        </ContentLoader>
                    </div>
                </Loading>
                <div id="getCourseClassActivityProgress_ContentFlex" className="activity_circle_container status-circle" style={{ display: 'flex', justifyContent: 'space-around' }}>
    {this.props.activityProgressRecords && this.props.activityProgressRecords.length > 0 &&
        this.props.activityProgressRecords.map(record => (
            <div
                key={Math.random() * 10000}
                className="lesson-counter animated slideInDown"
                style={{ minWidth: 'fit-content', marginBottom: '5px' }}
            >
                <span className="counter-label text-uppercase">{T.t('r_activity_type_' + record.type)}</span>
                <ProgressCircleLarge total={record.totalCount} count={record.completedCount} />
            </div>
        ))}
</div>


            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IActivityProgress): IActivityProgress => {
    if (!state) {
        return ownProps;
    }
    const newProps: IActivityProgress = Object.assign({}, ownProps, {
        coursePageClassId: state.coursePage.coursePageClassId,
        activityProgressRecords: state.coursePage.activityProgressRecords,
        activityProgressIsLoaded: state.coursePage.activityProgressIsLoaded
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId;
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CActivityProgress = connect(
    mapStateToProps,
    dispatchProps
)(ActivityProgress);

export default CActivityProgress;
